import api from '../../../config/axios'
import type { Calibration, CreateCalibrationRequest } from '../../../types/api'

export interface CalibrateSensorRequest {
  serial_number: string
  category: string
  type: string
  model: string
  measurement_range: number
  unit: string
  status?: string
  condition?: string
  is_active: boolean
  calibration_type: 'initial' | 'recalibration'
  input_data: {
    BOL: number
    raw_frequency: unknown[]
    temperature_frequency: Array<{
      condition: 'room' | 'high'
      frequency: number
      temperature: number
    }>
    ambient_temperature?: number
    humidity?: number
    weather_condition?: string
    atmospheric_pressure?: number
    dwt_traceable_certificate_no?: string
    equipment_calibration_certificate_no?: string
  }
}

export interface BulkCalibrateSensorsRequest {
  file: File
  sensor_type_id: string
  on_existing_serial?: 'recalibrate' | 'skip' | 'fail'
  condition?: string
  shared_input_data?: string
  meta_data?: string
}

export const CalibrationService = {
  calibrateSensor: (data: CalibrateSensorRequest) =>
    api.post<Calibration>('/sensors/calibrated', data).then(res => res.data),

  bulkCalibrateSensors: (data: BulkCalibrateSensorsRequest) => {
    const formData = new FormData()
    formData.append('file', data.file)
    formData.append('sensor_type_id', data.sensor_type_id)
    formData.append('on_existing_serial', data.on_existing_serial || '')
    formData.append('condition', data.condition || '')
    formData.append('shared_input_data', data.shared_input_data || '')
    formData.append('meta_data', data.meta_data || '')

    return api
      .post<Calibration>('/sensors/bulk-calibrated', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(res => res.data)
  },

  create: (data: CreateCalibrationRequest) => 
    api.post<Calibration>('/calibrations', data).then(res => res.data),

  getBySensorId: (sensorId: string) => 
    api.get<Calibration[]>('/calibrations', {
      params: {
        sensor_id: sensorId,
      },
    }).then(res => res.data),

  getAll: (params?: { skip?: number; limit?: number; sensor_id?: string }) => 
    api.get<Calibration[]>('/calibrations', {
      params: params || {},
    }).then(res => res.data),

  getById: (id: string) => 
    api.get<Calibration>(`/calibrations/${id}`).then(res => res.data),
}
